/* ca-compra.js: a compra da Çã sem recarregar a página. Liga todo form[data-ca-compra] (opção avulsa × assinatura,
   quantidade de 1 a 5, envio por /cart/add.js), a gaveta (#ca-gaveta: abrir, fechar, foco preso, − / + e remover por
   /cart/change.js), a página /cart e o contador do cabeçalho. Sem este arquivo tudo funciona como formulário comum. */
(function () {
  'use strict';

  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ROTA = { add: raiz + 'cart/add.js', change: raiz + 'cart/change.js', cart: raiz + 'cart' };
  var FALHA_REDE = 'Não deu para falar com a loja agora. Confira a conexão e tente de novo.';
  var FALHA = 'Não deu para atualizar o carrinho. Tente de novo.';
  var ocupado = false;
  var focoAntes = null;

  /* ---------- utilidades ---------- */
  function dois(n) { return (n < 10 ? '0' : '') + n; }

  function mensagem(dados, padrao) {
    if (dados) {
      if (typeof dados.description === 'string' && dados.description) return dados.description;
      if (typeof dados.message === 'string' && dados.message) return dados.message;
    }
    return padrao;
  }

  function lerJson(resposta) {
    return resposta.text().then(function (txt) {
      var dados = null;
      try { dados = txt ? JSON.parse(txt) : null; } catch (e) { dados = null; }
      return { ok: resposta.ok, status: resposta.status, dados: dados };
    });
  }

  function mostrarErro(el, txt) {
    if (!el) return;
    el.textContent = txt || '';
    el.hidden = !txt;
  }

  function avisarApps() {
    document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', { bubbles: true }));
  }

  function paginaCarrinho() { return document.querySelector('[data-ca-carrinho]'); }
  function gaveta() { return document.getElementById('ca-gaveta'); }

  function secoesPedidas() {
    var lista = [];
    if (gaveta()) lista.push('ca-gaveta');
    var pg = paginaCarrinho();
    if (pg && pg.getAttribute('data-section-id')) lista.push(pg.getAttribute('data-section-id'));
    return lista;
  }

  function lerHtml(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  /* ---------- contador do cabeçalho ---------- */
  function contador(n) {
    if (typeof n !== 'number' || isNaN(n)) return;
    document.querySelectorAll('[data-ca-contador]').forEach(function (el) { el.textContent = dois(n); });
    document.querySelectorAll('[data-ca-abrir-gaveta]').forEach(function (a) {
      a.setAttribute('aria-label', 'Carrinho, ' + n + (n === 1 ? ' item' : ' itens'));
    });
  }

  /* ---------- troca do HTML pela resposta da Section Rendering API ---------- */
  function trocarGaveta(html) {
    var g = gaveta();
    if (!g || !html) return null;
    var novo = lerHtml(html).querySelector('[data-ca-gaveta-corpo]');
    var atual = g.querySelector('[data-ca-gaveta-corpo]');
    if (!novo || !atual) return null;
    atual.parentNode.replaceChild(document.importNode(novo, true), atual);
    return parseInt(novo.getAttribute('data-contagem'), 10);
  }

  function trocarPagina(html) {
    var pg = paginaCarrinho();
    if (!pg || !html) return null;
    var novo = lerHtml(html).querySelector('[data-ca-carrinho]');
    if (!novo) return null;
    var n = parseInt(novo.getAttribute('data-contagem'), 10);
    var antes = parseInt(pg.getAttribute('data-contagem'), 10);
    // carrinho que esvaziou (ou que voltou a ter item): recarrega para refazer a página e os botões de pagamento
    if ((n === 0) !== (antes === 0)) { window.location.reload(); return n; }
    novo.querySelectorAll('[data-ca-troca]').forEach(function (parte) {
      var alvo = pg.querySelector('[data-ca-troca="' + parte.getAttribute('data-ca-troca') + '"]');
      if (alvo) alvo.parentNode.replaceChild(document.importNode(parte, true), alvo);
    });
    pg.setAttribute('data-contagem', String(n));
    return n;
  }

  function aplicar(secoes, contagem) {
    var n = null;
    if (secoes) {
      var g = trocarGaveta(secoes['ca-gaveta']);
      if (g !== null && !isNaN(g)) n = g;
      var pg = paginaCarrinho();
      if (pg) {
        var p = trocarPagina(secoes[pg.getAttribute('data-section-id')]);
        if (n === null && p !== null && !isNaN(p)) n = p;
      }
    }
    if (typeof contagem === 'number') n = contagem;
    if (n !== null) contador(n);
    return n;
  }

  /* ---------- gaveta: abrir, fechar, foco preso ---------- */
  function focaveis(caixa) {
    return [].slice.call(caixa.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0; });
  }

  function marcarLinks(aberta) {
    document.querySelectorAll('[data-ca-abrir-gaveta]').forEach(function (a) {
      a.setAttribute('aria-expanded', aberta ? 'true' : 'false');
    });
  }

  // gatilho: o elemento que recebe o foco de volta quando a gaveta fecha (o botão de compra, o link do carrinho)
  function abrir(gatilho) {
    var g = gaveta();
    if (!g) return false;
    var painel = g.querySelector('[data-ca-painel]');
    if (!g.classList.contains('is-open')) {
      focoAntes = gatilho || document.activeElement;
      g.classList.add('is-open');
      document.documentElement.classList.add('cc-travado');
      marcarLinks(true);
    }
    if (painel) window.requestAnimationFrame(function () { painel.focus({ preventScroll: true }); });
    return true;
  }

  function fechar() {
    var g = gaveta();
    if (!g || !g.classList.contains('is-open')) return;
    g.classList.remove('is-open');
    document.documentElement.classList.remove('cc-travado');
    marcarLinks(false);
    var volta = focoAntes;
    if (!volta || volta === document.body || !document.contains(volta) || g.contains(volta)) volta = document.querySelector('[data-ca-abrir-gaveta]');
    focoAntes = null;
    if (g.contains(document.activeElement)) document.activeElement.blur();
    if (volta && volta.focus) volta.focus({ preventScroll: true });
  }

  document.addEventListener('keydown', function (e) {
    var g = gaveta();
    if (!g || !g.classList.contains('is-open')) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); fechar(); return; }
    if (e.key !== 'Tab') return;
    var painel = g.querySelector('[data-ca-painel]');
    var lista = focaveis(painel);
    if (!lista.length) { e.preventDefault(); painel.focus(); return; }
    var primeiro = lista[0], ultimo = lista[lista.length - 1];
    var ativo = document.activeElement;
    if (e.shiftKey && (ativo === primeiro || ativo === painel || !painel.contains(ativo))) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && (ativo === ultimo || !painel.contains(ativo))) { e.preventDefault(); primeiro.focus(); }
  });

  /* ---------- linhas (gaveta e página): − / +, remover, campo de quantidade ---------- */
  function mudarLinha(linha, qtd, el) {
    if (ocupado || !linha || isNaN(qtd)) return;
    var area = el.closest('[data-ca-painel]') || el.closest('[data-ca-carrinho]') || document.body;
    var chave = el.getAttribute('data-ca-foco');
    ocupado = true;
    area.classList.add('cc-ocupado');
    area.setAttribute('aria-busy', 'true');
    mostrarErro(area.querySelector('[data-ca-erro-linhas]'), '');

    fetch(ROTA.change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: linha, quantity: qtd, sections: secoesPedidas(), sections_url: window.location.pathname })
    })
      .then(lerJson)
      .then(function (r) {
        if (!r.ok || !r.dados) {
          mostrarErro(area.querySelector('[data-ca-erro-linhas]'), mensagem(r.dados, FALHA));
          return;
        }
        aplicar(r.dados.sections, typeof r.dados.item_count === 'number' ? r.dados.item_count : undefined);
        avisarApps();
        devolverFoco(area, chave);
      })
      .catch(function () { mostrarErro(area.querySelector('[data-ca-erro-linhas]'), FALHA_REDE); })
      .then(function () {
        ocupado = false;
        area.classList.remove('cc-ocupado');
        area.removeAttribute('aria-busy');
      });
  }

  // depois da troca do HTML, o foco volta ao mesmo botão da mesma linha; se ele travou (no 1 ou no 5), vai ao outro
  // controle da mesma linha; se a linha saiu, ao título
  function devolverFoco(area, chave) {
    var alvo = null;
    if (chave) {
      var linha = chave.split('|')[0] + '|';
      var reserva = null;
      document.querySelectorAll('[data-ca-foco]').forEach(function (el) {
        if (!area.contains(el) || el.disabled) return;
        var k = el.getAttribute('data-ca-foco');
        if (!alvo && k === chave) alvo = el;
        if (!reserva && k.indexOf(linha) === 0) reserva = el;
      });
      if (!alvo) alvo = reserva;
    }
    if (!alvo) alvo = area.querySelector('[data-ca-pg-titulo]') || area.querySelector('[data-ca-painel]') || (area.matches && area.matches('[data-ca-painel]') ? area : null);
    if (alvo && alvo.focus) alvo.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var alvo = e.target.closest ? e.target : null;
    if (!alvo) return;

    var botaoLinha = alvo.closest('[data-ca-linha]');
    if (botaoLinha) {
      e.preventDefault();
      if (botaoLinha.disabled) return;
      mudarLinha(parseInt(botaoLinha.getAttribute('data-ca-linha'), 10), parseInt(botaoLinha.getAttribute('data-qtd'), 10), botaoLinha);
      return;
    }

    if (alvo.closest('[data-ca-fechar]')) { e.preventDefault(); fechar(); return; }

    // link do carrinho no cabeçalho: abre a gaveta (na própria página /cart, segue o link)
    var link = alvo.closest('[data-ca-abrir-gaveta]');
    if (link && gaveta() && !paginaCarrinho()) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
      e.preventDefault();
      abrir(link);
    }
  });

  // campo de quantidade da página /cart: o número digitado vai para o servidor ao sair do campo
  document.addEventListener('change', function (e) {
    var campo = e.target.closest ? e.target.closest('[data-ca-linha-campo]') : null;
    if (!campo) return;
    var max = parseInt(campo.getAttribute('max'), 10) || 5;
    var v = parseInt(campo.value, 10);
    if (isNaN(v) || v < 0) v = 0;
    if (v > max) v = max;
    campo.value = v;
    mudarLinha(parseInt(campo.getAttribute('data-ca-linha-campo'), 10), v, campo);
  });

  // Enter no campo de quantidade da página /cart atualiza a linha (sem isso, o Enter mandaria o formulário para o checkout)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var campo = e.target.closest ? e.target.closest('[data-ca-linha-campo]') : null;
    if (!campo) return;
    e.preventDefault();
    campo.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- formulário de compra (snippet ca-compra) ---------- */
  function opcaoAtual(form) { return form.querySelector('input[name="selling_plan"]:checked'); }

  function atualizarOpcao(form) {
    var marcada = opcaoAtual(form);
    mostrarErro(form.querySelector('[data-ca-erro]'), '');
    form.querySelectorAll('.cc-opt').forEach(function (rot) { rot.classList.toggle('is-on', !!marcada && rot.contains(marcada)); });
    if (!marcada) return;
    var garrafa = marcada.getAttribute('data-garrafa');
    if (garrafa) form.querySelectorAll('[data-ca-garrafa]').forEach(function (el) { el.textContent = garrafa; });
    // preço fora do bloco (ex.: o preço do alto da página de produto): qualquer [data-ca-preco] da mesma seção
    var preco = marcada.getAttribute('data-preco');
    var secao = form.closest('.shopify-section') || document;
    if (preco) secao.querySelectorAll('[data-ca-preco]').forEach(function (el) { el.textContent = preco; });
    form.dispatchEvent(new CustomEvent('ca:compra:opcao', {
      bubbles: true,
      detail: { sellingPlan: marcada.value || null, preco: preco || '' }
    }));
  }

  function estadoQtd(form) {
    var campo = form.querySelector('input[name="quantity"]');
    if (!campo) return;
    var min = parseInt(campo.min, 10) || 1;
    var max = parseInt(campo.max, 10) || 5;
    var v = parseInt(campo.value, 10);
    if (isNaN(v)) v = min;
    v = Math.min(max, Math.max(min, v));
    campo.value = v;
    form.querySelectorAll('[data-ca-qtd]').forEach(function (b) {
      var passo = parseInt(b.getAttribute('data-ca-qtd'), 10);
      b.disabled = passo < 0 ? v <= min : v >= max;
    });
  }

  function enviar(form, e) {
    e.preventDefault();
    var botao = form.querySelector('[data-ca-botao]');
    if (!botao || botao.disabled || form.getAttribute('aria-busy') === 'true') return;
    // sem gaveta na página, o formulário segue o caminho normal (cai em /cart)
    if (!gaveta()) { form.submit(); return; }

    var erro = form.querySelector('[data-ca-erro]');
    mostrarErro(erro, '');
    estadoQtd(form);

    var dados = new FormData(form);
    if (!dados.get('selling_plan')) dados.delete('selling_plan');
    dados.append('sections', secoesPedidas().join(','));
    dados.append('sections_url', window.location.pathname);

    var texto = botao.textContent;
    botao.textContent = 'Adicionando…';
    botao.disabled = true;
    form.setAttribute('aria-busy', 'true');

    fetch(ROTA.add, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: dados
    })
      .then(lerJson)
      .then(function (r) {
        if (!r.ok || !r.dados) {
          mostrarErro(erro, mensagem(r.dados, 'Não deu para adicionar ao carrinho. Tente de novo.'));
          return;
        }
        var n = aplicar(r.dados.sections);
        if (n === null) { window.location.href = ROTA.cart; return; }
        avisarApps();
        abrir(botao);
      })
      .catch(function () { mostrarErro(erro, FALHA_REDE); })
      .then(function () {
        botao.textContent = texto;
        botao.disabled = false;
        form.removeAttribute('aria-busy');
      });
  }

  function iniciarForm(form) {
    if (form.getAttribute('data-ca-pronto')) return;
    form.setAttribute('data-ca-pronto', '1');
    form.querySelectorAll('input[name="selling_plan"]').forEach(function (r) {
      r.addEventListener('change', function () { atualizarOpcao(form); });
    });
    form.querySelectorAll('[data-ca-qtd]').forEach(function (b) {
      b.addEventListener('click', function () {
        var campo = form.querySelector('input[name="quantity"]');
        if (!campo) return;
        campo.value = (parseInt(campo.value, 10) || 1) + parseInt(b.getAttribute('data-ca-qtd'), 10);
        estadoQtd(form);
        mostrarErro(form.querySelector('[data-ca-erro]'), '');
      });
    });
    var campo = form.querySelector('input[name="quantity"]');
    if (campo) campo.addEventListener('change', function () { estadoQtd(form); });
    form.addEventListener('submit', function (e) { enviar(form, e); });
    atualizarOpcao(form);
    estadoQtd(form);
  }

  function iniciar(escopo) {
    (escopo || document).querySelectorAll('form[data-ca-compra]').forEach(iniciarForm);
  }

  /* ---------- volta pelo botão "voltar" do navegador: contador e gaveta podem estar velhos ---------- */
  function recarregarSecoes() {
    var lista = secoesPedidas();
    if (!lista.length) return;
    fetch(window.location.pathname + '?sections=' + encodeURIComponent(lista.join(',')), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (secoes) { if (secoes) aplicar(secoes); })
      .catch(function () {});
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) recarregarSecoes(); });

  /* ---------- editor de temas ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    iniciar(e.target);
    if (e.target.querySelector && e.target.querySelector('#ca-gaveta')) document.documentElement.classList.remove('cc-travado');
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector && e.target.querySelector('#ca-gaveta')) abrir();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector && e.target.querySelector('#ca-gaveta')) fechar();
  });

  marcarLinks(false);
  iniciar(document);
})();
